
import renderRoute from './render-route';
import { keys } from '../../00-base/global/utils/keycodes';
import announce from '../../00-base/global/utils/announce';


const tokenReplacements = {
    '@title': 'title',
    '@label': 'labelFormatted'
}
export default class AccessibleMarker  {

    constructor(markerData, map, directionsService, directionsRenderer, locateUserCallback, containingOverlay) {

        const markerTypeInfo = markerData.markerTypeInfo;

        this.map_ = map;



        this.markerElement_ = null;
        this.data_ = markerData;
        this.data_.labelFormatted = this.data_.label ? this.data_.label + ' ' : '';

        this.latLng_ = new google.maps.LatLng(markerData.position.lat, markerData.position.lng);
        this.directionsService_ = directionsService;
        this.directionsRenderer_ = directionsRenderer;

        this.currentPosition_ = null;

        this.locateUser = locateUserCallback || function (position) { };

        this.id_  = `${markerData.mapId}-${markerTypeInfo.markerTypeId}-${markerData.markerIndex}`
        this.localDirsHeadingId_ = 'dirs-heading';
        this.directionsHeadingId_ = this.getScopedId(this.localDirsHeadingId_);
        this.markerElementId_ = this.getScopedId('li');
        this.loadingParagraphId_ = this.getScopedId('loading-text');

        this.isHorizontal_ = true;

        this.containingOverlay_ = containingOverlay;
        this.isLoading_ = false;

        this.loadingText_ = this.insertMarkerTokens(this.data_.contentLabels.directionsLoadingText);
        this.headingText_ = this.insertMarkerTokens(this.data_.contentLabels.titleFormat);
    }
    

    insertMarkerTokens(label) {
        const result = Object.keys(tokenReplacements).reduce((accumulator, curr) => {
            if (!accumulator) {
                return '';
            } else if (!(curr && curr in tokenReplacements && tokenReplacements[curr] in this.data_)) {
                return accumulator;
            } else {
                return accumulator.replace(curr, this.data_[tokenReplacements[curr]]);
            }
        }, label);

        return result;
    }

    closePopup() {
        this.markerButton_.setAttribute('aria-pressed', 'false');
        this.map_.currentPopup = null;
        this.isOpen_ = false;
    }

    closeAndFocus() {
        this.markerButton_.focus();
        setTimeout(() => this.closePopup(), 1);
    }

    isWithinBounds() {
        const bounds = this.map_.getPaddingAdjustedBounds();

        return bounds.contains(this.latLng_);
    }



    getScopedId(id) {
        return `${this.id_}-${id}`;
    }

    wrapHeading(levelDelta, classes, content, id) {
        const hLevel = this.data_.headingLevel + levelDelta;
        const fullId = this.getScopedId(id);
        return {html: `<h${hLevel} class="${classes.join(' ')}" id="${fullId}">${content}</h${hLevel}>`, id: fullId};
    }

    renderMarkerContents(isLabelRedundant) {
        const ariaHiddenAttr = isLabelRedundant || !this.data_.label ? 'aria-hidden="true"' : '';
        return ` <img src="${this.data_.markerTypeInfo.icon}" class="custom-map-marker" aria-hidden="true" alt="" />
                    <span class="marker-label" ${ariaHiddenAttr}>${this.data_.label || this.data_.markerTypeInfo.default_label}</span>`;
    }

    getMarkerClass() {
        return `custom-map-marker-display custom-map-marker-display-${this.data_.markerTypeInfo.markerTypeId}`;
    }

    renderMarkerButton() {
        const markerTypeClass = this.getMarkerClass();
        const labelText = this.data_.label ? `${this.data_.label} ` : '';
        return `<button aria-pressed="false" aria-label="${labelText} ${this.data_.title}" data-marker-id="${this.id_}" data-map-index="${this.data_.mapIndex}"
                    id="${this.getScopedId('marker-button-main')}"    
                    class="js-custom-map-marker-button custom-map-marker-button ${markerTypeClass}">
                        ${this.renderMarkerContents(false)}
                </button>`
    }

    renderMarkerElement() {
        return `<span class="${this.getMarkerClass()} custom-map-marker-inline">${this.renderMarkerContents(false)}</span>`
    }

    renderHeading() {
        return this.wrapHeading(0, ['marker-info-heading'], this.headingText_, 'heading').html;
    }

    renderDescription() {
        return `<div class="marker-description-content">${this.data_.description}</div>`;
    }

    renderMarkerActions() {
        const apiRoot = 'https://www.google.com/maps/dir/?api=1';
        const linkDest = `${this.data_.position.lat},${this.data_.position.lng}`;
        const universalUrl = `${apiRoot}&destination=${linkDest}&travelmode=walking&dir_action=navigate&hl=${this.data_.mapLang}`;

        return `<ul class="marker-actions-list" aria-label="${this.data_.contentLabels.markerActionsLabel}">
                    <li>
                        <a href="${universalUrl}" id="${this.getScopedId('lnk-gmaps')}" target="_maps" class="link" aria-label="${this.insertMarkerTokens(this.data_.contentLabels.openLinkLabelFull)}">
                            ${this.data_.contentLabels.openLinkLabelShort}
                        </a>
                    </li>
                    <li><button class="js-refresh-directions link">${this.data_.contentLabels.directionsButtonLabel}</button></li>
                </ul>`;
    }

    renderDirectionsLoadingMessage() {
        return `<div class="loading-container ajax-progress">
                    <p class="visually-hidden" id="${this.loadingParagraphId_}">${this.loadingText_}</p>
                    <div class="throbber" aria-hidden="true"> </div>
                </div>`
    }

    getDirectionsContainer() {
        
        const dirsHeading = this.wrapHeading(1, ['directions-heading', 'visually-hidden'], this.insertMarkerTokens(this.data_.contentLabels.directionsHeadingText), 'dirs-heading');
        
        return {html: `<div class="directions-container">
                    ${dirsHeading.html}
                    <div class="directions-content"></div>
                </div>`, headingId: dirsHeading.id};
    }

    renderErrorContainer() {
        return `<div class="js-custom-gmap-error-container status-messages  status-messages--error directions-errors"> 
                    ${this.wrapHeading(1, ['error-heading', 'visually-hidden'], this.data_.contentLabels.errorHeadingText, 'dirs-error').html}
                    <div class="js-custom-gmap-error-content status--error"></div>
                </div>`;
    }

    renderCloseButton() {
        return `<button class="close-desc-button js-close-desc-button" 
                    id="${this.getScopedId('btn-close')}"
                    aria-label="${this.insertMarkerTokens(this.data_.contentLabels.closeLabelFull)}">
                        <img alt="" aria-hidden="true" src="/themes/custom/cmhr/components/images/icons/Icon-Close.svg" />
                </button>`;
    }

    getOverlayContent() {
        const directionsCont = this.getDirectionsContainer();
        return {html: `<div class="custom-map-overlay-content js-custom-map-overlay-content">
                    ${this.renderHeading()}
                    <div class="custom-map-marker-desc">
                        ${this.renderDescription()}
                        ${this.renderMarkerActions()}
                        ${this.renderDirectionsLoadingMessage()}
                        ${directionsCont.html}
                        ${this.renderErrorContainer()}
                    </div>
                    ${this.renderCloseButton()}
                </div>`, directionsHeadingId: directionsCont.headingId};
    }

    showError(errorText) {      
        this.overlayPopup_.classList.add('has-error');
        this.errorContainer_.innerHTML = `<p>${errorText}</p>`;
        announce(`${this.data_.contentLabels.errorText} ${errorText}`);
    }

    clearError() {
        this.overlayPopup_.classList.remove('has-error');
        this.errorContainer_.innerHTML = '';
    }

    setLoading() {
        this.isLoading_ = true;
        this.overlayPopup_.classList.add('is-loading');
        if (this.refreshButton_) {
            this.refreshButton_.setAttribute('aria-disabled', 'true');
            this.refreshButton_.setAttribute('aria-describedby', this.loadingParagraphId_);
        }
    }

    clearLoading() {
        this.isLoading_ = false;
        this.overlayPopup_.classList.remove('is-loading');
        if (this.refreshButton_) {
            this.refreshButton_.setAttribute('aria-disabled', 'false');
            this.refreshButton_.removeAttribute('aria-describedby');
        }
    }

    getOverlayPadding() {
        const defaultPadding = this.map_.defaultPadding || {
            top: 40, left: 20, right: 40, bottom: 40
        };

        const newPadding = Object.assign({}, defaultPadding);

        if (this.isHorizontal_) {
            newPadding.left = this.overlayPopup_.getBoundingClientRect().width;
        } else {
            newPadding.top += this.overlayPopup_.getBoundingClientRect().height;
        }

        return newPadding;
    }

    loadDirections(initLoadingCallback, doneCallback) {

        const prevDirs = this.dirsPanel_.innerHTML;

        this.clearError();
        this.setLoading();
        if (initLoadingCallback) {
            initLoadingCallback();
        }

        const doneFunc = doneCallback || function () { };

        navigator.geolocation.getCurrentPosition((position, timestamp) => {



            this.locateUser(position);
            const originLatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);


       
            if (this.currentPosition_ && this.currentPosition_.lat() === originLatLng.lat() && this.currentPosition_.lng() === originLatLng.lng()) {

                this.clearLoading();
                this.dirsPanel_.innerHTML = prevDirs;
                this.directionsRenderer_.setDirections(this.directionsRenderer_.getDirections());
                announce(this.insertMarkerTokens(this.data_.contentLabels.directionsLoadedText));
                doneFunc();
            }

            const directionsRequest = {
                origin: originLatLng,
                destination: this.latLng_,
                travelMode: google.maps.TravelMode.WALKING,
            };

            this.directionsService_.route(directionsRequest, (result, status) => {
           
                
                doneFunc();
                this.clearLoading();
                if (status == 'OK' && result.routes && result.routes.length > 0) {
                 
                    this.directionsRenderer_.setDirections(result); 
                    
                    const routeHtml = renderRoute(result.routes[0], this.directionsHeadingId_, 
                                            this.data_.contentLabels.yourLocationText,
                                            this.data_.title, 
                                            this.data_.contentLabels, '', this.renderMarkerElement() );
                    this.dirsPanel_.innerHTML = routeHtml;
                    this.currentPosition_ = originLatLng;

                    const routeBounds = result.routes[0].bounds;

            
               
                    const padding = this.getOverlayPadding();

                 

                    this.map_.fitBounds(routeBounds, padding);
                    announce(this.insertMarkerTokens(this.data_.contentLabels.directionsLoadedText));

                } else {
                    console.log(status);
                    doneFunc();
                    this.showError(this.data_.contentLabels.errorText);
                    this.currentPosition_ = null;
                }
            });
        }, e => { 
            this.clearLoading();
            this.currentPosition_ = null;
            const message = e.code === 1 ? this.data_.contentLabels.noLocationMessageText : this.data_.contentLabels.errorText;
            this.showError(message);
            console.log(e);
            doneFunc(); 
        }); 
    }

    renderMarker() {
        const overlayContainer = this.getOverlayContent();
        return  `<li class="custom-map-accessible-marker custom-map-marker-${this.data_.markerTypeInfo.markerTypeId}"
                        id="${this.markerElementId_}">
                        ${this.renderMarkerButton()}${overlayContainer.html}
                    </li>`;
    };


    getMarkerElement() {
        if (!this.markerElement_) {

        }
    }


    postRender(topEl) {

        
        const referenceEl = topEl || document;

        this.markerElement_ = referenceEl.querySelector(`#${this.markerElementId_}`);

        const markerButton = this.markerElement_.querySelector('.js-custom-map-marker-button');

        this.markerButton_ = markerButton;




        this.overlayPopup_ = this.markerElement_.querySelector('.js-custom-map-overlay-content');
        this.overlayPopup_.addEventListener('keyup', (e) => {
            if (e && e.keyCode == keys.esc) {
                this.closeAndFocus();
            }
        });

        this.dirsPanel_ = this.overlayPopup_.querySelector('.directions-content');

        this.errorContainer_ = this.overlayPopup_.querySelector('.js-custom-gmap-error-container');

        this.refreshButton_ = this.overlayPopup_.querySelector('.js-refresh-directions');

        this.markerButton_.addEventListener('click', () => {
            if (this.isOpen_) {
                this.closePopup();
            } else {
                this.openPopup();
            }
        });

        if (this.refreshButton_) {
            this.refreshButton_.addEventListener('click', e => {
                if (!this.isLoading_) {
                    announce(this.loadingText_);
                    this.loadDirections()
                }
            });
        }


        this.closeBtn_ = this.overlayPopup_.querySelector('.js-close-desc-button');
        this.closeBtn_.addEventListener('click', () => this.closeAndFocus());

        this.lastOverlayFocus_ = this.closeBtn_;
        this.firstOverlayFocus_ = this.overlayPopup_.querySelector('.marker-actions-list li:first-child *');
    }

    openPopup() {
       if (this.map_.currentPopup) {
            this.map_.currentPopup.closePopup();
       }

       // pressedButtons.forEach(btn => this.closePopupFromButton(btn));
        this.markerButton_.setAttribute('aria-pressed', 'true');
        this.map_.currentPopup = this;
        this.loadDirections();
        this.isOpen_ = true;
    }

    positionPopup(containerRect, isHorizontal) {
        const childPopup = this.overlayPopup_;

        childPopup.style.left = (containerRect.width / 2 * -1) + 'px';
        childPopup.style.top = (containerRect.height / 2 * -1) + 'px';


        this.isHorizontal_ = isHorizontal;
        const popupHeightMultiplier = this.isHorizontal_ ? 1 : 0.5;

        childPopup.style.height = (containerRect.height * popupHeightMultiplier) + 'px';

    }

    positionPopupSingle() {
        this.positionPopup(this.containingOverlay_.getContainerRect(), this.containingOverlay_.isHorizontal());
    }

    draw(containerRect,  isHorizontal) {

        
        const latLngPx = this.containingOverlay_.getLatLngToDivPixel(this.latLng_);


        const markerEl = this.markerButton_;
        const markerRect = markerEl.getBoundingClientRect();

        const left = (latLngPx.x - (markerRect.width / 2));
        const top = (latLngPx.y - markerRect.height);
        markerEl.style.left = left + 'px';
        markerEl.style.top = top + 'px';

        
        this.positionPopup(containerRect, isHorizontal);

    }

}
